import { Pipe, PipeTransform } from '@angular/core';
import { ReplacementPair } from '@catch/libs';

function escapeRegex(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

@Pipe({
  name: 'resolvePlaceholders',
  standalone: true,
})
export class ResolvePlaceholdersPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    replacements: ReplacementPair | null | undefined
  ): string {
    let result = value || '';
    if (!replacements) {
      return result;
    }

    // Longest originals first so legacy `(a|b|c)` blocks win over nested §tokens§
    // and over shorter patterns. Escape originals — `|`/`()` must stay literal.
    const ordered = Object.values(replacements).sort(
      (left, right) => right.original.length - left.original.length
    );

    for (const pair of ordered) {
      if (!pair?.original) {
        continue;
      }
      result = result.replace(
        new RegExp(escapeRegex(pair.original), 'g'),
        () => pair.replacement ?? ''
      );
    }

    return result;
  }
}
